module.exports = __webpack_public_path__ + "img/Cookie_1_resize_06.eb1710e7.png";